import { clsx } from "@trydig/ui";
import type { ComponentProps, ReactNode } from "react";
import {
	AssetBlok,
	multiAssetToSingleAsset,
	sizes,
} from "@/components/bloks/Asset";
import type { BlokHeroFullVideo, StoryblokMultiasset } from "@/storyblok";
import styles from "./HeroFullVideo.module.css";

export interface HeroFullVideoProps
	extends Pick<BlokHeroFullVideo, "mainTitle" | "secondaryTitle">,
		ComponentProps<"section"> {
	mainSource?: StoryblokMultiasset;
	lightMode?: boolean;
	cta?: ReactNode;
}

export const HeroFullVideo = ({
	mainTitle,
	secondaryTitle,
	mainSource,
	lightMode,
	cta,
	className,
	...rest
}: HeroFullVideoProps) => {
	return (
		<section className={clsx(styles.root, className)} {...rest}>
			<div className={styles.text}>
				<div className={styles.sentinel} />
				<h1 className={styles.title} data-light={lightMode}>
					<span>{mainTitle}</span>
					<span>{secondaryTitle}</span>
				</h1>
				{cta && <div className={styles.cta}>{cta}</div>}
			</div>
			<div className={clsx(styles.asset, styles.mainAsset)}>
				{mainSource?.length && (
					<AssetBlok
						source={multiAssetToSingleAsset(mainSource!)}
						muted
						autoPlay
						loop
						priority
						soundControlLight={lightMode}
						quality={90}
						sizes={sizes(90, 50)}
					/>
				)}
			</div>
		</section>
	);
};
